import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { WorkflowEditorPage } from '@/features/workflows/graph/workflow-editor';

/** Créer un workflow dans l'éditeur de graphe (ADR 0102) ; l'assistant pas à pas reste sur `new`. */
export const Route = createFileRoute('/$tenant/projects/$projectId/workflows/editor')({
  component: NewWorkflowEditorRoute,
});

function NewWorkflowEditorRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="workflows"
      crumbs={[{ label: t('nav.items.workflows') }, { label: t('workflowEditor.newTitle') }]}
    >
      <WorkflowEditorPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
